import DepsService from 'services/dependencies';

const CONTEXT = 'earnings';

export const fetchEarnings = (retailerId) => {
  const { url } = DepsService.rest.widgets.earnings;
  const queryParams = {};
  const urlParams = { retailerId };
  const path = 'widgets.earnings';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};

export const fetchNetEarnings = (retailerId) => {
  const { url } = DepsService.rest.widgets.netEarnings;
  const queryParams = {};
  const urlParams = { retailerId };
  const path = 'widgets.earnings';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/earnings.api.js